<template>
  <div class="leftContent-multipara">
    <div class="mx-auto">
      <b-container fluid>
        <b-row>
          <b-col col="12" class="head w-100">
            <Headings :data="heading" className="white_color" />
          </b-col>
          <b-row class="left-last-content">
            <b-col>
              <p
                class="para text-justify w-100"
                v-for="(para,index) in paragraphs"
                :key="index"
              >{{ para }}</p>
            </b-col>
          </b-row>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftContent-multipara",
  props: ["heading", "paragraphs"],
};
</script>

<style scoped>
.left-last-content {
  color: var(--mainBlueColor);
  padding-top: 2rem;
  text-align: left;
}
.container-fluid {
  padding-left: 0px;
}
.para {
  color: white;
}
.head {
  padding-left: 0;
}

@media (max-width: 768px) {
  .left-last-content {
    color: var(--mainBlueColor);
    padding-top: 2rem;
    text-align: justify;
    padding-left: 15px;
  }
  .para {
    font-size: 0.75rem;
  }
  .head {
    padding-left: 15px;
  }
}
</style>
